<div class="d-flex gap-3">
  <magieno-input-text-field
          class="flex-fill"
          [advancedFormControl]="this.childForm.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>

  <magieno-input-text-field
          class="flex-fill"
          [advancedFormControl]="this.childForm.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
</div>

<div class="d-flex mt-3">
  <magieno-datepicker
          [advancedFormControl]="this.childForm.formElements.birthdate | asAdvancedFormControl">
    <i class="fas fa-calendar" calendarIcon></i>
  </magieno-datepicker>
</div>

<div class="mt-3">
  <magieno-boolean-select
          [advancedFormControl]="this.childForm.formElements.isDisabled | asAdvancedFormControl"></magieno-boolean-select>
</div>

<div class="mt-3 mb-4">
  <magieno-input-money-field [locale]="this.locale"
                             [currency]="this.currency"
                             [advancedFormControl]="this.childForm.formElements.netIncome | asAdvancedFormControl"></magieno-input-money-field>
</div>


@if (incomeTaxPersonalForm.value.isCareExpensesCalculated === true) {
  <h3 id="informations-sur-frais-de-garde">Informations sur les frais de garde</h3>
  <div class="d-flex gap-3">
    <magieno-input-money-field
            class="flex-fill"
            [locale]="this.locale"
            [currency]="this.currency"
            [advancedFormControl]="federalForm.formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
    <magieno-input-money-field
            class="flex-fill"
            [locale]="this.locale"
            [currency]="this.currency"
            [advancedFormControl]="quebecForm.formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
  </div>

  <app-salary-dividend-personal-tax-child-camps-form [form]="form"
                                                     [camps]="camps"></app-salary-dividend-personal-tax-child-camps-form>

}




